var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M146.986,90.78a1.668,1.668,0,0,1,.53,1.22,1.69,1.69,0,0,1-.53,1.23,1.715,1.715,0,0,1-2.46,0,1.709,1.709,0,0,1-.51-1.23,1.686,1.686,0,0,1,.51-1.22,1.692,1.692,0,0,1,2.46,0m9.67-.53a1.794,1.794,0,0,0-1.75,1.75,1.679,1.679,0,0,0,.52,1.23,1.648,1.648,0,0,0,1.23.52,1.776,1.776,0,0,0,1.75-1.75,1.658,1.658,0,0,0-.52-1.22,1.69,1.69,0,0,0-1.23-.53m17.52-25.32v37.45a4.156,4.156,0,0,1-1.26,2.99,4.09,4.09,0,0,1-3.02,1.28h-2.29V77.46a3.928,3.928,0,0,0-3.99-3.99h-11.69v33.18h-1.52V73.47h-11.68a3.81,3.81,0,0,0-2.81,1.15,3.877,3.877,0,0,0-1.15,2.84v29.19h-2.32a4.393,4.393,0,0,1-4.27-4.27V64.93a4.062,4.062,0,0,1,1.29-3.02,4.117,4.117,0,0,1,2.98-1.26H169.9a4.3,4.3,0,0,1,4.28,4.28m-27.21,2.34-4.35-2.58-4.34,2.58v2.57l4.34-2.58,4.35,2.58Zm16.67-2.58-4.34,2.58-4.35-2.58v2.57l4.35,2.58,4.34-2.58Z",
    transform: "translate(-128.176 -60.65)",
    fill: "#939598"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.e00bc40c576daacd84ff8164abfbd067.svg";
export { ForwardRef as ReactComponent };